import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useDateRangePickerStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
        },
        fieldContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
        },
        startFieldContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            marginRight: theme.spacing(2),
        },
        fieldRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        title: {
            marginBottom: 5,
            fontSize: 14,
        },
        fieldLabel: {
            display: 'inline-block',
            marginRight: theme.spacing(1),
            whiteSpace: 'nowrap',
            color: '#7a786f',
        },
    }),
);
